import { Chip, ChipProps, SxProps, Theme } from '@mui/material';

export default function ChipButton({ label, onClick, variant = 'outlined', icon, sx, ...otherProps }: ChipProps) {
    const defaultSx: SxProps<Theme> = {
        display: { xs: 'none', sm: 'inline-flex' },
        '& .MuiChip-label': {
            typography: 'subtitle2',
        },
        '& .MuiChip-icon': {
            typography: 'button',
        },
        padding: '6px 10px 6px 10px',
        borderColor: 'cement.200',
    };
    const chipSx = {
        ...defaultSx,
        ...sx, // Allow custom sx to override defaults
    };
    return <Chip onClick={onClick} sx={chipSx} variant={variant} label={label} icon={icon} clickable {...otherProps} />;
}
